export function imageLazyLoading() {

    $('[data-src]').each((i, ele) => {
        if ($(window).scrollTop() >= ($(ele).offset().top - $(window).height() - 100) && $(ele).is(':visible')){
            const dataSrc = $(ele).attr('data-src'), src = $(ele).attr('src');
            $(ele).removeAttr('data-src').attr('src', dataSrc);
            $(ele).on('error', () => {
                 $(ele).attr('src', src);
            });
        }
    });

    $('.slick-slider.js--lazy-loading').each((index, ele) => {
        if ($(window).scrollTop() >= ($(ele).offset().top - $(window).height() - 200)) {
            $(ele).find('img[data-img]').each((index, img) => {
                const dataImg = $(img).attr('data-img');
                $(img).removeAttr('data-img').attr('data-lazy', dataImg);
            });
            $(ele).removeClass('js--lazy-loading');
            $(ele).slick('refresh');
        }
    });
}

$(imageLazyLoading);
$(window).scroll(imageLazyLoading);